import { render, staticRenderFns } from "./myordershowinfo.vue?vue&type=template&id=773d5f50&scoped=true&"
import script from "./myordershowinfo.vue?vue&type=script&lang=js&"
export * from "./myordershowinfo.vue?vue&type=script&lang=js&"
import style0 from "./myordershowinfo.vue?vue&type=style&index=0&id=773d5f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d5f50",
  null
  
)

export default component.exports